import type { NavItemType } from "@wbly/data-storefront";
import type { Marketplace } from "@wbly/client";

export type PillItem = {
  label: string;
  url: string;
  link?: string;
};

// Remove current category Level 2 category from the pathname
// and replace it with the new category set in the Pridmic field.
// This allows content to selecte a specific subcategory of items to display
// in pills.

export function buildCategoryPathname(
  taxonCategoryName: string,
  currentPathname: string,
  marketplace: Marketplace
): string {
  if (!taxonCategoryName) return currentPathname;

  const relativePath = currentPathname.replace(
    `/${marketplace.identifier}`,
    ""
  );
  const relativePathArray = relativePath.split("/");

  // Return null if the path is already at the 3rd level.
  if (relativePathArray.length > 4) {
    return null;
  }

  const pathname = currentPathname
    .split("/")
    .splice(0, 4)
    .concat(taxonCategoryName)
    .join("/");

  return pathname;
}

export function getPillsTaxon(
  pathname: string,
  navItems: NavItemType[],
  marketplace: Marketplace
): PillItem[] | null {
  const items = [];

  if (!pathname || !navItems) return null;

  for (const item of navItems) {
    // Check both potential children arrays.
    for (const key of ["submenu", "items"]) {
      const children = item[key];

      if (children?.length) {
        // Check if we are in 2nd level category.
        // If that's the case we then return the filtered children.
        const isSecondLevel = children.some(
          (child: NavItemType) =>
            child.link === pathname || child.url === pathname
        );

        if (isSecondLevel) {
          return children.filter(
            (child: NavItemType) =>
              child.link !== pathname && child.url !== pathname
          );
        }

        // Continue recursion
        const found = getPillsTaxon(pathname, children, marketplace);

        if (found) items.push(...found);
      }
    }
  }

  // This is the case where we are in a 3rd level category.
  // We need to filter out the current category from the pills.
  const filteredItems = items.filter((item) => item.url !== pathname);

  return filteredItems.length ? filteredItems : null;
}
